import { render, staticRenderFns } from "./analysisFun2.vue?vue&type=template&id=06243696&scoped=true&"
import script from "./analysisFun2.vue?vue&type=script&lang=js&"
export * from "./analysisFun2.vue?vue&type=script&lang=js&"
import style0 from "./analysisFun2.vue?vue&type=style&index=0&id=06243696&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06243696",
  null
  
)

export default component.exports